/* ---------- Script to fix the product page Carousel Start -------- */


(function () {
  'use strict';

  const MAX_ATTEMPTS = 40;
  const RETRY_DELAY = 250;

  let attempts = 0;
  let retryTimer = null;

  function initProductGallery() {
    const gallery = document.querySelector('.product-gallery__main');

    // Gallery doesn't exist yet
    if (!gallery) {
      retry();
      return;
    }

    // Flickity hasn't loaded yet
    if (typeof Flickity === 'undefined') {
      retry();
      return;
    }

    /* =========================================
       1. INITIALIZE / GET FLICKITY
    ========================================= */

    let flkty = Flickity.data(gallery);

    // Theme failed to initialize it
    if (!flkty) {
      flkty = new Flickity(gallery, {
        accessibility: true,
        adaptiveHeight: true,

        cellAlign: 'center',

        draggable: '>1',
        dragThreshold: 10,

        fade: false,

        freeScrollFriction: 0.075,
        friction: 0.28,

        imagesLoaded: true,

        namespaceJQueryEvents: true,

        pageDots: false,
        pauseAutoPlayOnHover: true,

        percentPosition: true,

        prevNextButtons: true,

        resize: true,

        selectedAttraction: 0.025,

        setGallerySize: true,

        watchCSS: false,

        wrapAround: true
      });

      console.log(
        '[Product Gallery] Flickity fallback initialized'
      );
    }


    /* =========================================
       2. FIND THUMBNAILS
    ========================================= */

    const productGallery = gallery.closest('.product-gallery');

    const thumbnailContainer = productGallery
      ? productGallery.querySelector('.product-gallery__thumbnails')
      : document.querySelector('.product-gallery__thumbnails');

    if (!thumbnailContainer) {
      return;
    }

    const thumbnails = Array.from(
      thumbnailContainer.querySelectorAll(
        '.product-gallery__thumbnail'
      )
    );

    if (!thumbnails.length) {
      return;
    }


    /* =========================================
       3. ACTIVE THUMBNAIL
    ========================================= */

    function setActiveThumbnail(index) {
      thumbnails.forEach(function (thumbnail, i) {
        thumbnail.classList.toggle(
          'is-nav-selected',
          i === index
        );
      });
    }


    /* =========================================
       4. THUMBNAIL → MAIN SLIDER
    ========================================= */

    thumbnails.forEach(function (thumbnail, index) {

      // Prevent duplicate listeners
      if (thumbnail.dataset.flickityNavBound === 'true') {
        return;
      }

      thumbnail.dataset.flickityNavBound = 'true';

      thumbnail.addEventListener('click', function (event) {

        event.preventDefault();

        flkty.select(index);

        setActiveThumbnail(index);

      });

    });


    /* =========================================
       5. MAIN SLIDER → THUMBNAIL
    ========================================= */

    if (gallery.dataset.thumbnailSyncBound !== 'true') {

      gallery.dataset.thumbnailSyncBound = 'true';

      flkty.on('change', function (index) {
        setActiveThumbnail(index);
      });

    }


    /* =========================================
       6. INITIAL STATE
    ========================================= */

    setActiveThumbnail(flkty.selectedIndex);

    // Successfully initialized — stop retries
    if (retryTimer) {
      clearTimeout(retryTimer);
      retryTimer = null;
    }
  }


  /* =========================================
     RETRY FOR W3 DELAYED JS
  ========================================= */

  function retry() {

    if (attempts >= MAX_ATTEMPTS) {
      console.warn(
        '[Product Gallery] Flickity initialization timed out'
      );
      return;
    }

    // Prevent multiple retry timers
    if (retryTimer) {
      return;
    }

    attempts++;

    retryTimer = setTimeout(function () {
      retryTimer = null;
      initProductGallery();
    }, RETRY_DELAY);
  }


  /* =========================================
     START
  ========================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initProductGallery,
      { once: true }
    );

  } else {

    initProductGallery();

  }



  /* =========================================
     W3 SPEEDUP FALLBACK
  ========================================= */

  window.addEventListener(
    'w3-load',
    initProductGallery,
    { once: true }
  );

})();



/* ---------- Script to fix the product page Carousel End -------- */